<div class="container">
    <mat-card appearance="outlined">
        <mat-card-title>Forget Password</mat-card-title>
        <mat-card-subtitle></mat-card-subtitle>
        <mat-card-content>
            <form [formGroup]="forgotPasswordForm" (ngSubmit)="forgotPasswordForm.valid && forgotPassword()" novalidate>
                <div class="row">
                    <div class="col-md-12">
                        <mat-form-field>
                            <input matInput type="text" placeholder="Email" name="userEmail" id="userEmail"
                                formControlName="userEmail">
                        </mat-form-field>
                    </div>
                </div>
            </form>
        </mat-card-content>
        <div *ngIf="isLoaderResult"
             style="display:flex; justify-content:center; align-items:center; position:absolute; top:40%; left:35%;">
            <mat-spinner color="warn"></mat-spinner>
        </div>
         <mat-card-footer style="padding: 10px 15px;">
  <div style="display: flex; justify-content: center; gap: 10px;">
    <button md-raised-button type="button" class="btn btn-round btn-rose"
            (click)="close()">Close</button>
    <button md-raised-button type="button" class="btn btn-round btn-rose"
            (click)="forgotPassword()" [disabled]="!forgotPasswordForm.valid">Submit</button>
  </div>
</mat-card-footer>
    </mat-card>
</div>